
import { Component, OnInit,ElementRef,ChangeDetectorRef} from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { PeticionesService } from '../servicios/httpservice';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataDBService } from '../servicios/data-db.service';


@Component({
  selector: 'app-transitos',
  templateUrl: './transitos.component.html',
  styleUrls: ['./transitos.component.css']
})
export class TransitosComponent implements OnInit {
  public arrayAccesos:any=[];
  public tagName:any;
  public DatosUsuario:any;

  public entro: number = 0;
  public arrayTimer: any = [];
  public arrayCallApi: any = [];
  public strAlm_Origen: string;
  public strAlm_destino: string;

  public arrayEncabezadoOrigen: any;
  public arrayEncabezadoDestino: any;
  public arrayVehiculos: any;
  public origen: number;
  public destino: number;
  public arrayCuerpo: any;
  public ArrayAlmacen: any;
  public ArrayArticulos: any;
  public ArrayArticulosAgregados: any;
  public sumaVolumen: number = 0;
  public strArticulo: string;
  public intCantidad: number;
  public arrayEncabezados: any;
  public strBusqueda: string = "";
  public almacenOrigen: number = -1;
  public almacenDestino: number = -1;
  public strAlmacenOrigen: string;
  public strAlmacenDestino: string;
  public spiner: boolean = true;
  public contErrores: number = 0;
  public arrayErrores: any;
  public arraySelect: any;
  public numinici: number;
  public numfin: number;
  public arrayInventario: any;
  public dblAvance: number = 0;
  public dblTotalExcedente: number = 0;
  public strLinea: string = '';
  public intOpcion: number;

  constructor( private route: ActivatedRoute,private changeDetectorRef: ChangeDetectorRef,private indexedDBService: DataDBService,private _httpService: PeticionesService, private router: Router, elem: ElementRef,private modal: NgbModal) {     
    this.tagName = elem.nativeElement.tagName.toLowerCase();
    this.indexedDBService.getItem('arrayResult', (value) => {
      this.arrayAccesos=value?value:[];
      console.log(this.arrayAccesos[0])
      this.DatosUsuario = this.arrayAccesos[0]
      if (this.arrayAccesos.length > 0) {
        console.log(this.arrayAccesos[0]);
        this.DatosUsuario = this.arrayAccesos[0];

        this.ArrayAlmacen = [{ strAlmacenOrien: 'Almacen01', strAlmacenDestino: 'AlmacenD02' }];

        this.ArrayArticulos = [
          { strArticulo: "ART 01", strDescripcion: "DES 01", intCantidad: "0", intExistenciaSuc: 12, intExistenciaLeon: 14, dblPromedio: 6, intMICS: 65, intLlegar: 14, intVender: 45 },
          { strArticulo: "ART 02", strDescripcion: "DES 02", intCantidad: "0", intExistenciaSuc: 18, intExistenciaLeon: 25, dblPromedio: 8, intMICS: 45, intLlegar: 47, intVender: 65 },
          { strArticulo: "ART 03", strDescripcion: "DES 03", intCantidad: "0", intExistenciaSuc: 59, intExistenciaLeon: 84, dblPromedio: 5, intMICS: 78, intLlegar: 58, intVender: 23 },
          { strArticulo: "ART 04", strDescripcion: "DES 04", intCantidad: "0", intExistenciaSuc: 63, intExistenciaLeon: 12, dblPromedio: 1, intMICS: 11, intLlegar: 69, intVender: 14 },
          { strArticulo: "ART 05", strDescripcion: "DES 05", intCantidad: "0", intExistenciaSuc: 45, intExistenciaLeon: 14, dblPromedio: 6, intMICS: 65, intLlegar: 14, intVender: 50 },
          { strArticulo: "ART 06", strDescripcion: "DES 06", intCantidad: "0", intExistenciaSuc: 85, intExistenciaLeon: 25, dblPromedio: 8, intMICS: 45, intLlegar: 47, intVender: 10 },
          { strArticulo: "ART 07", strDescripcion: "DES 07", intCantidad: "0", intExistenciaSuc: 10, intExistenciaLeon: 84, dblPromedio: 5, intMICS: 78, intLlegar: 58, intVender: 83 },
          { strArticulo: "ART 08", strDescripcion: "DES 08", intCantidad: "0", intExistenciaSuc: 20, intExistenciaLeon: 78, dblPromedio: 1, intMICS: 11, intLlegar: 69, intVender: 19 },
        ];
        this.ArrayArticulosAgregados = [];
    
        this.strArticulo = '';
        this.intCantidad = 0;
        this.strAlmacenOrigen = '';
        this.strAlmacenDestino = '';
        this.strAlm_Origen = '';
        this.strAlm_destino = '';
     
        this.origen = 0;
        this.destino = 0;
        this.numinici = 0;
        this.numfin = 0;
        this.intOpcion = 0;
        console.log(this.strLinea);
        console.log(this.DatosUsuario);
        this.route.queryParams.subscribe(params => {
          this.strLinea = params['linea'];
          this.intOpcion = params['opcion'];
          this.strAlm_destino = params['destino'];
          this.strAlm_Origen = params['origen'];
    
        });
        this.fnGetVehiculos();
        this.fnGetExcedente();
        this.fngetOrigenDestino();
      } else {
        this.router.navigate(['/login']);
      }
    });


  }

  ngOnInit(): void {
  

 

   
  }

  
  fnGetExcedente() {
    let objTransito = {
      strAccion: 'getTotalExcedente',
      strLinea: this.strLinea,
      strUsuario: this.DatosUsuario.strUsuario,
      strAlm_Origen: this.intOpcion == 2 ? this.strAlm_Origen : '',
      strOpcion: 'transito'
    }
    this._httpService.getLogisticaPlaneador(
      objTransito
    ).subscribe(
      result => {

        this.dblTotalExcedente = result.length > 0 ? parseInt(result[0].code) : 0;
        console.log('---total excedente-----------');
        console.log(this.dblTotalExcedente);
        let accion = this.intOpcion == 1 ? 'getTransitos' : parseInt(this.strAlm_destino) < 0 ? 'getTransitosOrigenDest' : 'getTransitosOrigenDest_2_nuevo';
          const body = {
            strAccion: accion, intIndice1: 1, intIndice2: 2, strLinea: this.strLinea,
            strUsuario: this.DatosUsuario.strUsuario,          
            strAlm_Origen: this.strAlm_Origen,
            strAlm_destino: this.strAlm_destino
          }
 
          this._httpService.ejecutarSPPorLotes(body,1, this.dblTotalExcedente, 100).subscribe({
            next: (resultados) => {
              this.spiner = true
              console.log('Resultados:', resultados);
              let result =resultados[resultados.length -1]
              this.fnGetAlmOrigen(result);
            },
            error: (error) => {
              console.error('Error al ejecutar SP:', error);
            }
          });

        /*let aumento = (this.dblTotalExcedente > 500 && this.intOpcion == 1) ? 8 : 90;
        let tiempo = (this.dblTotalExcedente > 500 && this.intOpcion == 1) ? 2500 : 2800;
        //dividir en lotes de 200
        let time = 0;
        for (let i = 1; i <= this.dblTotalExcedente; i += aumento + 1) {
          let algo = this.dblTotalExcedente + 2
          let indice1 = i;
          let indice2 = (i + aumento) >= (this.dblTotalExcedente) ? this.dblTotalExcedente + 2 : (i + aumento);
          this.arrayCallApi.push({ indice1: indice1, indice2: indice2, result: 0 });


        }

        console.log('total de indices' + this.arrayCallApi.length)
        console.log(this.arrayCallApi);
        this.arrayCallApi.forEach((element: any) => {
          setTimeout(() => {


            this.fnGetTransitos(element.indice1, element.indice2, this.dblTotalExcedente);


          }, time);

          time = time + 2500;

        });*/

      });
  }






  fnGetTransitos(indice1: number, indice2: number, total: number) {
    let accion = this.intOpcion == 1 ? 'getTransitos' : parseInt(this.strAlm_destino) < 0 ? 'getTransitosOrigenDest' : 'getTransitosOrigenDest_2';
    console.log(accion);
    let objAct = {
      strAccion: accion, intIndice1: indice1, intIndice2: indice2, strLinea: this.strLinea,
      strUsuario: this.DatosUsuario.strUsuario,
      strAlm_Origen: this.strAlm_Origen,
      strAlm_destino: this.strAlm_destino
    }
    this._httpService.getLogisticaPlaneador(objAct).subscribe(
      result => {

        console.log(result)
        let res = (result.length > 0 && result.length == 1) ? result[0].code == 200 ? result[0].code : 220 : result.length > 1 ? 220 : 409;
        console.log('respuesta: ' + res)
        let opcion = 0;
        if (res == 200) {
          //this.dblAvance=this.dblAvance+1;
          this.dblAvance = this.dblAvance + 1;
          let intIndice1 = result[0].intIndice1;
          let intIndice2 = result[0].intIndice2;
          console.log('-----------------------indices----------------')
          console.log('indice 1= ' + indice1 + 'indice 2= ' + indice2);

          let aux = this.arrayCallApi.find((o: any) => o.indice1 == intIndice1 && o.indice2 == intIndice2);
          aux.result = 1;
          opcion = 1;
        }
        else if (res == 220) {
          let intIndice1 = result[0].intIndice1;
          let intIndice2 = result[0].intIndice2;
          console.log('-----------------------indices----------------')
          console.log('indice 1= ' + intIndice1 + ' indice 2= ' + intIndice2);
          let aux = this.arrayCallApi.find((o: any) => o.indice1 == intIndice1 && o.indice2 == intIndice2);
          opcion = 2;
          if (aux) {
            aux.result = 1;
          }

          //  this.arrayCuerpo=result;
          //obtener los encabezado
          // this.fnGetAlmOrigen(result);



        }
        if (this.entro == 1 && res == 220) {
          this.fnGetAlmOrigen(result);
        }
        else {
          this.FNVALIDA(result, total, opcion);
        }


      },
      error => {
        console.log('Error:', error);
        console.log('---------de nuevo--------------indices------------------');
        console.log('indice 1= ' + indice1 + ' indice 2= ' + indice2);
        console.log(this.arrayCallApi);
        let time = 1000
        let timeoutId: ReturnType<typeof setTimeout>;


        timeoutId = setTimeout(() => {
          this.fnGetTransitos(indice1, indice2, total)
        }, time);
        this.arrayTimer.push({ idTime: timeoutId });






      });
    console.log('-----------------------indices----------------')
    console.log(indice1);
    console.log(indice2);
  }
  FNVALIDA(result: any, total: number, opcion: number) {
    //validar cuantos marcaron error
    let array_error: any = this.arrayCallApi.filter((o: any) => o.result == 0);
    console.log(this.arrayCallApi);
    console.log('Faltan= ' + array_error.length)
    console.log(array_error)
    if (array_error.length == 0 && opcion == 2 && this.entro == 0) {// si no se encontraron errores
      this.entro = 1;
      console.log('---------FIN--------------EXITOSO------------------');
      console.log(this.arrayCallApi);
      this.fnGetAlmOrigen(result);


      //LIMPIAR TIMER
      this.arrayTimer.forEach((element: any) => {
        clearTimeout(element.idTime);
      });
    } //de lo contrario, volver a llamar el metodo
    else if (array_error.length > 0) {
      console.log('enviar de nuevo')

      let in1 = array_error[0].indice1;
      let in2 = array_error[0].indice2;
      let time = 100;
      let timeoutId: ReturnType<typeof setTimeout>;


      timeoutId = setTimeout(() => {
        console.log('-------se reenvia-------');
        this.fnGetTransitos(in1, in2, total);
      }, time);
      this.arrayTimer.push({ idTime: timeoutId });
      console.log(this.arrayTimer);
    }
    else {

      //LIMPIAR TIMER
      this.arrayTimer.forEach((element: any) => {
        clearTimeout(element.idTime);
      });
      this.arrayTimer = []
    }
  }
  fnGetAlmOrigen(cuerpo: any) {
    this.arrayEncabezadoOrigen = [];
    this._httpService.getLogisticaPlaneador({ strAccion: 'getAlmOrigen' }).subscribe(
      result => {
        //this.arrayEncabezadoOrigen=result;
        this.fnGetAlmDestino(result, cuerpo);

      });

  }
  fnGetAlmDestino(arrayEncabezadoOrigen: any, cuerpo: any) {
    this.arrayEncabezadoDestino = [];
    this._httpService.getLogisticaPlaneador({ strAccion: 'getAlmDestino' }).subscribe(
      result => {
        this.arrayEncabezadoDestino = result;
        /*       this.arrayEncabezadoOrigen=arrayEncabezadoOrigen; */

        this.arrayCuerpo = cuerpo;
        this.arrayEncabezadoDestino.forEach((element: any) => {
          element.arrayVehiculos = [];
          element.arrayVehiculos = this.filtrarVehiculos(element.strAlm_Origen);
          element.vehiculoSeleccionado = "";//element.arrayVehiculos[0];

        });
        this.arrayCuerpo.forEach((element: any) => {
          element.almCambio = 0;
        });
        this.arrayEncabezadoDestino.forEach((element: any) => {
          let arrayresult = this.arrayCuerpo.filter((o: any) => o.strAlm_Origen == element.strAlm_Origen && o.strAlm_destino == element.strAlm_destino);
          let arrayresultVuelta = this.arrayCuerpo.filter((o: any) => o.strAlm_Origen == element.strAlm_destino && o.strAlm_destino == element.strAlm_Origen);
          element.arrayresult = arrayresult;
          element.arrayresultVuelta = arrayresultVuelta;
          element.flecha = 0;
          console.log('entra aqui');
          let respaldo = JSON.parse(JSON.stringify(arrayresult));//copia profunda de arrayresult
          element.objNuevoAlm = { strAlm_Origen: element.strAlm_Origen, strAlm_OrigenNombre: element.strAlm_OrigenNombre, arrayresult2: respaldo };

        });
        console.log(this.arrayEncabezadoDestino);
        /*    console.log(this.arrayEncabezadoOrigen);

           console.log( this.arrayEncabezadoDestino); */

        this.spiner = false;

      });

  }
  fngetOrigenDestino() {
    this._httpService.getLogisticaPlaneador({ strAccion: 'getNombresAlmacen' }).subscribe(
      resultados => {
        this.arrayEncabezados = resultados.sort((x: any, y: any) => x.strNombreAlm.localeCompare(y.strNombreAlm));;
        console.log(this.arrayEncabezados);
      });
  }
  fnGetVehiculos() {
    this.arrayVehiculos = [];
    this._httpService.getLogisticaPlaneador({ strAccion: 'getVehiculos' }).subscribe(
      result => {
        console.log('getVehiculos')
        this.arrayVehiculos = result;

      })
  }
  filtrarVehiculos(almacen_origen: number) {
    let sucursal = almacen_origen == 1 ? 0 : almacen_origen;
    let vehiculoArr = this.arrayVehiculos.filter((o: any) => o.strSucursal == sucursal)
    return vehiculoArr;
  }
  sumarVolumen(origen: number, destino: number, ind: number, flecha: number): number | undefined {
    if (flecha == 0) {
      let filteredResults = this.arrayEncabezadoDestino.filter((o: any) => o.strAlm_Origen === origen && o.strAlm_destino === destino);
      let arrayResult = filteredResults[0].arrayresult;
      let suma = arrayResult.reduce((acumulador: number, registro: any) => acumulador + registro.dblVolumen, 0);
      return suma;
    } else if (flecha == 1) {
      let filteredResults = this.arrayEncabezadoDestino.filter((o: any) => o.strAlm_Origen === origen && o.strAlm_destino === destino);
      let arrayResult = filteredResults[0].arrayresultVuelta;
      let suma = arrayResult.reduce((acumulador: number, registro: any) => acumulador + registro.dblVolumen, 0);
      return suma;
    } else {
      return 0;
    }




  }
  sumarPeso(origen: number, destino: number, indice: number, flecha: number): number | undefined {
    if (flecha == 0) {
      let filteredResults = this.arrayEncabezadoDestino.filter((o: any) => o.strAlm_Origen === origen && o.strAlm_destino === destino);
      let arrayResult = filteredResults[0].arrayresult;
      let suma = arrayResult.reduce((acumulador: number, registro: any) => acumulador + registro.dblPeso, 0);
      return suma;
    } else if (flecha == 1) {
      let filteredResults = this.arrayEncabezadoDestino.filter((o: any) => o.strAlm_Origen === origen && o.strAlm_destino === destino);
      let arrayResult = filteredResults[0].arrayresultVuelta;
      let suma = arrayResult.reduce((acumulador: number, registro: any) => acumulador + registro.dblPeso, 0);
      return suma;
    } else {
      return 0;
    }


  }
  sumarCantidad(origen: number, destino: number, indice: number, flecha: number): number  {
    // console.log( this.arrayEncabezadoDestino[indice].arrayresultVuelta)
    if (flecha == 0) {
      let filteredResults = this.arrayEncabezadoDestino.filter((o: any) => o.strAlm_Origen === origen && o.strAlm_destino === destino);
      let arrayResult = filteredResults[0].arrayresult;
      let suma = arrayResult.reduce((acumulador: number, registro: any) => acumulador + registro.dblCantidad, 0);
      return suma;
    } else if (flecha == 1) {
      let filteredResults = this.arrayEncabezadoDestino.filter((o: any) => o.strAlm_Origen === origen && o.strAlm_destino === destino);
      let arrayResult = filteredResults[0].arrayresultVuelta;
      let suma = arrayResult.reduce((acumulador: number, registro: any) => acumulador + registro.dblCantidad, 0);
      return suma;
    } else {
      return 0;
    }

  }

  sumarVolumenT(origen: number, destino: number, flecha: number): number  {
    if (flecha == 0) {
      let filteredResults = this.arrayEncabezadoDestino.filter((o: any) => o.strAlm_Origen === origen && o.strAlm_destino === destino);
      let arrayResult = filteredResults[0].arrayresult;
      let suma = arrayResult.reduce((acumulador: number, registro: any) => acumulador + (registro.dblVolumen * registro.dblCantidad), 0);
      return suma;
    } else if (flecha == 1) {
      let filteredResults = this.arrayEncabezadoDestino.filter((o: any) => o.strAlm_Origen === origen && o.strAlm_destino === destino);
      let arrayResult = filteredResults[0].arrayresultVuelta;
      let suma = arrayResult.reduce((acumulador: number, registro: any) => acumulador + (registro.dblVolumen * registro.dblCantidad), 0);
      return suma;
    } else {
      return 0;
    }

  }
  sumarPesoT(origen: number, destino: number, indice: number, flecha: number): number  {
    if (flecha == 0) {
      let filteredResults = this.arrayEncabezadoDestino.filter((o: any) => o.strAlm_Origen === origen && o.strAlm_destino === destino);
      let arrayResult = filteredResults[0].arrayresult;
      let suma = arrayResult.reduce((acumulador: number, registro: any) => acumulador + (registro.dblPeso * registro.dblCantidad), 0);
      return suma;
    } else if (flecha == 1) {
      let filteredResults = this.arrayEncabezadoDestino.filter((o: any) => o.strAlm_Origen === origen && o.strAlm_destino === destino);
      let arrayResult = filteredResults[0].arrayresultVuelta;
      let suma = arrayResult.reduce((acumulador: number, registro: any) => acumulador + (registro.dblPeso * registro.dblCantidad), 0);
      return suma;
    } else {
      return 0;
    }
  }
  //CERRAR MODAL
  cerrarModal() {
    this.modal.dismissAll();
  }

  fnAgregaArticulo() {
    console.log('Agregar Articulo')

    this.ArrayArticulos.forEach((element: any) => {
      let obj = element;

      if (this.strArticulo == element.strArticulo) {
        this.ArrayArticulosAgregados.push(obj)
        this.cerrarModal();
        this.strArticulo = '';
      }

    });

  }
  fnQuitarArticulo(indice: number) {
    //console.log(indice)
    //alert("Entra")
    this.arrayCuerpo.splice(indice, 1);
    const indices = this.arrayCuerpo.findIndex((elemento: any) => elemento.id === indice);
    if (indice !== -1) {
      this.arrayCuerpo.splice(indices, 1);
      this.changeDetectorRef.detectChanges();
    }

  }

  fnAbrirModal(listado: any) {
    this.modal.open(listado, { size: 'lg' });
  }

  cambiarCantidad(obj: any, cantidad: number) {
    obj.dblCantidad = cantidad;
  }
  fnSetTransito(alm_origen: string, alm_origenCuerpo: string, alm_Destino: string, vehiculo: any, flecha: number) {
    console.log(alm_origen + "//////////" + alm_Destino);
    let xmlArticulos: any;
    if (flecha == 0) {
      let filteredResults = this.arrayEncabezadoDestino.filter((o: any) => o.strAlm_Origen === alm_origen && o.strAlm_destino === alm_Destino);
      let arrayResult = filteredResults[0].arrayresult.filter((o: any) => o.dblCantidad > 0);

      xmlArticulos = arrayResult;
    } else if (flecha == 1) {
      let filteredResults = this.arrayEncabezadoDestino.filter((o: any) => o.strAlm_Origen === alm_origen && o.strAlm_destino === alm_Destino);
      let arrayResult = filteredResults[0].arrayresultVuelta;
      xmlArticulos = arrayResult;
    }

    //  let xmlArticulos= this.arrayCuerpo.filter(o=>o.strAlm_Origen==alm_origen&&o.strAlm_destino==alm_Destino);
    let objTransito = {
      strAccion: 'setTransito', strAlm_Origen: alm_origen, strAlm_destino: alm_Destino, strAgente: vehiculo.strAgente, xmlArticulos: xmlArticulos,
      strUsuario: this.DatosUsuario.strUsuario
    }
    console.log(objTransito);
    this.spiner = true;
    this._httpService.getLogisticaPlaneador(objTransito).subscribe(
      result => {
        console.log(result);
        this.fnGetVehiculos();

        //  this.arrayCuerpo=result;
        let id = result[0].code;
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Se generó Tránsito con ID :' + id,
          showConfirmButton: true
        });

        this.fndeletearray(parseInt(alm_origen), parseInt(alm_origenCuerpo), parseInt(alm_Destino), flecha);
        this.fnGetAlmOrigen(this.arrayCuerpo);
        (result);
      });
  }
  fnEliminarObjeto(strAlm_destino: string, strAlm_Origen: any, strArticulo: string, strOpcion: string) {
    let objTransito = {
      strAccion: 'deleteArticulo',
      strAlm_destino: strAlm_destino,
      strAlm_Origen: strAlm_Origen,
      strArticulo: strArticulo,
      strOpcion: strOpcion
    }
    this.spiner = true;
    this._httpService.getLogisticaPlaneador(objTransito).subscribe(
      result => {
        this.fnGetAlmOrigen(this.arrayCuerpo);
      });
  }
  cambia_alm_origen(almd: any) {
    //respaldo original
    console.log(almd.objNuevoAlm.arrayresult2[0].dblCantidad)
    //obtenemos el nombre del almacen
    let nombre = this.arrayEncabezados.find((o: any) => o.strAlmacen == almd.strAlm_Origen);

    almd.strAlm_OrigenNombre = nombre.strNombreAlm;
    //obtenemos los excedentes en el nuevo almacen origen
    let objTransito = {
      strAccion: 'getDisponible_Cambio',
      strAlm_destino: almd.strAlm_destino,
      strAlm_Origen: almd.objNuevoAlm.strAlm_Origen,
      intAlmacen: almd.strAlm_Origen,
      strUsuario: this.DatosUsuario.strUsuario
    }
    if (almd.strAlm_Origen == almd.objNuevoAlm.strAlm_Origen) {
      let respaldo = JSON.parse(JSON.stringify(almd.objNuevoAlm.arrayresult2));//copia a profundidad de arrayresult2
      almd.arrayresult = respaldo;


    }
    else {
      this._httpService.getLogisticaPlaneador(objTransito).subscribe(
        result => {
          let resultado = result;
          let respaldo = [...almd.arrayresult];
          respaldo.forEach((element: any) => {
            let nuevaC = resultado.find((o: any) => o.strArticulo == element.strArticulo && o.strOpcion == element.strOpcion);
            element.dblCantidad = nuevaC.dblCantidad;
            this.arrayCuerpo.forEach((ele: any) => {

              if (ele.strArticulo == element.strArticulo && ele.strOpcion == element.strOpcion && ele.strAlm_Origen == almd.objNuevoAlm.strAlm_Origen && ele.strAlm_destino == almd.strAlm_destino) {
                ele.strAlm_Origen == almd.strAlm_Origen;
                ele.strAlm_OrigenNombre == almd.strAlm_OrigenNombre;
              }
            });
          });
          almd.arrayresult = respaldo;
          console.log(result);
        });
    }

  }
  /*  fnCambio_Origen()
    {

    } */

  fnEliminar(strOrigen: number, strDestino: number, v: number, art: any, opcion: any) {
    this.arrayEncabezadoDestino.forEach((element: any) => {
      if (element.strAlm_Origen == strOrigen && element.strAlm_destino == strDestino) {
        if (element.flecha == 0) {
          element.arrayresult.splice(v, 1)
          this.arrayEncabezadoDestino.forEach((element1: any) => {
            if (element1.strAlm_Origen == strDestino && element1.strAlm_destino == strOrigen) {
              if (element1.flecha == 1) {
                element1.arrayresultVuelta.splice(v, 1)
              }
            }
          });


          //eliminar del array original
          console.log(this.arrayCuerpo);
          let objC = this.arrayCuerpo.findIndex((o: any) => o.strAlm_Origen == strOrigen && element.strAlm_destino == strDestino && o.strArticulo == art && o.strOpcion == opcion);
          console.log(objC);
          // Si se encontró el objeto, eliminarlo utilizando splice()
          if (objC !== -1) {
            this.arrayCuerpo.splice(objC, 1);
          }
          console.log(this.arrayCuerpo);
        } else if (element.flecha == 1) {
          element.arrayresultVuelta.splice(v, 1)
          /*  this.arrayEncabezadoDestino.forEach(element1 => {
             if(element1.strAlm_Origen == strDestino  && element1.strAlm_destino == strOrigen ){
               if(element1.flecha == 0){
                 element1.arrayresult.splice(v, 1);
               }
            }
           }); */
        }
      }
    });

  }
  tieneRegistros(almOrigen: string, almDestino: string): boolean {
    return this.arrayCuerpo.some((registro: any) =>
      registro.strAlm_Origen === almOrigen && registro.strAlm_destino === almDestino
    );
  }
  filtrarTransitos(): void {
    // Filtrar los resultados según las selecciones de almacén origen y destino
    this.arrayCuerpo = this.arrayCuerpo.filter((registro: any) =>
      registro.strAlm_Origen === this.almacenOrigen && registro.strAlm_destino === this.almacenDestino
    );
  }

  fnCambiarArrayDestino(i: number) {
    if (this.arrayEncabezadoDestino[i].flecha == 0) {
      this.arrayEncabezadoDestino[i].flecha = 1
    } else if (this.arrayEncabezadoDestino[i].flecha == 1) {
      this.arrayEncabezadoDestino[i].flecha = 0
    }
  }

  fnUnificar(origen: number, destino: number, union: number) {
    console.log(origen, destino, union);
    let arrayObjPasar = this.arrayEncabezadoDestino.filter((o: any) => o.strAlm_Origen == origen && o.strAlm_destino == destino).map((o: any) => o.arrayresult).flat();
    console.log(arrayObjPasar);
    this.arrayEncabezadoDestino.forEach((obj: any) => {
      if (obj.strAlm_Origen == origen && obj.strAlm_destino == union) {
        obj.arrayresult.push(...arrayObjPasar);
        const newStrAlmacen = obj.arrayresult[0].strAlm_Origen;
        const newStrAlmacenNombre = obj.arrayresult[0].strAlm_OrigenNombre;
        obj.arrayresult.forEach((item: any) => {
          item.strAlm_Origen = newStrAlmacen;
          item.strAlm_OrigenNombre = newStrAlmacenNombre;
        });
      }
    });
    this.arrayEncabezadoDestino.forEach((obj: any) => {
      if (obj.strAlm_Origen == origen && obj.strAlm_destino == destino) {
        obj.arrayresult = [];
      }
      if (obj.arrayresult.length > 0) {
        const cantidades: Record<string, any> = {};
        for (const objeto of obj.arrayresult) {
          const strArticulo = objeto.strArticulo;
          const strUnidad = objeto.strUnidad;
          const strOpcion = objeto.strOpcion;
          const strNombreOpcion = objeto.strNombreOpcion;
          const strDescripcion = objeto.strDescripcion;
          const strCaso = objeto.strCaso;
          const strAlmacen = objeto.strAlmacen;
          const strAlm_destinoNombre = objeto.strAlm_destinoNombre;
          const strAlm_destino = objeto.strAlm_destino;
          const strAlm_OrigenNombre = objeto.strAlm_OrigenNombre;
          const strAlm_Origen = objeto.strAlm_Origen;
          const intTransito = objeto.intTransito;
          const intPorvender = objeto.intPorvender;
          const intPorSurtir = objeto.intPorSurtir;
          const intMes = objeto.intMes;
          const intIndice2 = objeto.intIndice2;
          const intIndice1 = objeto.intIndice1;
          const intID = objeto.intID;
          const intExistencia = objeto.intExistencia;
          const intCompras = objeto.intCompras;
          const intAlmacen = objeto.intAlmacen;
          const dblVolumen = objeto.dblVolumen;
          const dblValor = objeto.dblValor;
          const dblPromedio = objeto.dblPromedio;
          const dblPeso = objeto.dblPeso;
          const dblCantidad = objeto.dblCantidad;
          if (cantidades.hasOwnProperty(strArticulo)) {
            cantidades[strArticulo].dblCantidad += dblCantidad;
            cantidades[strArticulo].dblVolumen += dblVolumen;
            cantidades[strArticulo].dblPeso += dblPeso;
            cantidades[strArticulo].strUnidad = strUnidad;
            cantidades[strArticulo].strOpcion = strOpcion;
            cantidades[strArticulo].strNombreOpcion = strNombreOpcion;
            cantidades[strArticulo].strDescripcion = strDescripcion;
            cantidades[strArticulo].strCaso = strCaso;
            cantidades[strArticulo].strAlmacen = strAlmacen;
            cantidades[strArticulo].strAlm_destinoNombre = strAlm_destinoNombre;
            cantidades[strArticulo].strAlm_destino = strAlm_destino;
            cantidades[strArticulo].strAlm_OrigenNombre = strAlm_OrigenNombre;
            cantidades[strArticulo].strAlm_Origen = strAlm_Origen;
            cantidades[strArticulo].intTransito = intTransito;
            cantidades[strArticulo].intPorvender = intPorvender;
            cantidades[strArticulo].intPorSurtir = intPorSurtir;
            cantidades[strArticulo].intMes = intMes;
            cantidades[strArticulo].intIndice2 = intIndice2;
            cantidades[strArticulo].intIndice1 = intIndice1;
            cantidades[strArticulo].intID = intID;
            cantidades[strArticulo].intExistencia = intExistencia;
            cantidades[strArticulo].intCompras = intCompras;
            cantidades[strArticulo].intAlmacen = intAlmacen;
            cantidades[strArticulo].dblValor = dblValor;
            cantidades[strArticulo].dblPromedio = dblPromedio;
          } else {
            cantidades[strArticulo] = {
              dblCantidad: dblCantidad,
              dblVolumen: dblVolumen,
              dblPeso: dblPeso,
              strUnidad: strUnidad,
              strOpcion: strOpcion,
              strNombreOpcion: strNombreOpcion,
              strDescripcion: strDescripcion,
              strCaso: strCaso,
              strAlmacen: strAlmacen,
              strAlm_destinoNombre: strAlm_destinoNombre,
              strAlm_destino: strAlm_destino,
              strAlm_OrigenNombre: strAlm_OrigenNombre,
              strAlm_Origen: strAlm_Origen,
              intTransito: intTransito,
              intPorvender: intPorvender,
              intPorSurtir: intPorSurtir,
              intMes: intMes,
              intIndice2: intIndice2,
              intIndice1: intIndice1,
              intID: intID,
              intExistencia: intExistencia,
              intCompras: intCompras,
              intAlmacen: intAlmacen,
              dblValor: dblValor,
              dblPromedio: dblPromedio
            };
          }
        }

        // Crear un nuevo array con los objetos únicos
        const arrayObjetosUnicos = [];
        for (const nombreArticulo in cantidades) {
          arrayObjetosUnicos.push({
            strArticulo: nombreArticulo,
            dblCantidad: cantidades[nombreArticulo].dblCantidad,
            dblVolumen: cantidades[nombreArticulo].dblVolumen,
            dblPeso: cantidades[nombreArticulo].dblPeso,
            strUnidad: cantidades[nombreArticulo].strUnidad,
            strOpcion: cantidades[nombreArticulo].strOpcion,
            strNombreOpcion: cantidades[nombreArticulo].strNombreOpcion,
            strDescripcion: cantidades[nombreArticulo].strDescripcion,
            strCaso: cantidades[nombreArticulo].strCaso,
            strAlmacen: cantidades[nombreArticulo].strAlmacen,
            strAlm_destinoNombre: cantidades[nombreArticulo].strAlm_destinoNombre,
            strAlm_destino: cantidades[nombreArticulo].strAlm_destino,
            strAlm_OrigenNombre: cantidades[nombreArticulo].strAlm_OrigenNombre,
            strAlm_Origen: cantidades[nombreArticulo].strAlm_Origen,
            intTransito: cantidades[nombreArticulo].intTransito,
            intPorvender: cantidades[nombreArticulo].intPorvender,
            intPorSurtir: cantidades[nombreArticulo].intPorSurtir,
            intMes: cantidades[nombreArticulo].intMes,
            intIndice2: cantidades[nombreArticulo].intIndice2,
            intIndice1: cantidades[nombreArticulo].intIndice1,
            intID: cantidades[nombreArticulo].intID,
            intExistencia: cantidades[nombreArticulo].intExistencia,
            intCompras: cantidades[nombreArticulo].intCompras,
            intAlmacen: cantidades[nombreArticulo].intAlmacen,
            dblValor: cantidades[nombreArticulo].dblValor,
            dblPromedio: cantidades[nombreArticulo].dblPromedio
          });
        }


        obj.arrayresult.length = 0;
        Array.prototype.push.apply(obj.arrayresult, arrayObjetosUnicos); // Agregar los elementos del nuevo array
        console.log(obj.arrayresult);
      }

    });
  }
  fnunif(array: any, strAlm: number): any {
    let arrai = array.filter((o: any) => o.strAlm_Origen == strAlm);
    return arrai;
  }

  fndeletearray(origen: number, origenCuerpo: number, destino: number, flecha: number) {
    console.log(origen, destino, flecha)
    this.arrayEncabezadoDestino.forEach((item: any) => {
      if (item.strAlm_Origen == origen && item.strAlm_destino == destino) {
        if (flecha == 0) {
          item.arrayresult = [];
          this.arrayEncabezadoDestino.forEach((item: any) => {
            if (item.strAlm_Origen == destino && item.strAlm_destino == origen) {
              item.arrayresultVuelta = [];
            }
          });
        } else if (flecha == 1) {
          item.arrayresultVuelta = [];
          item.flecha = 0;
          /*   this.arrayEncabezadoDestino.forEach(item => {
              if(item.strAlm_Origen == destino && item.strAlm_destino== origen){
                item.arrayresult=[];
              }
            }); */
        }
      }
    });
    console.log(this.arrayCuerpo);
    this.arrayCuerpo = this.arrayCuerpo.filter((element2: any) => {
      return !(element2.strAlm_Origen == origenCuerpo && element2.strAlm_destino == destino);
    });
    console.log(this.arrayCuerpo);

  }
  formatDescripcion(descripcion: string): string {
    // Agregar el salto de línea en la posición deseada
    const posicionSalto = Math.floor(descripcion.length / 2);
    const descripcionFormateada = `${descripcion.slice(0, posicionSalto)}<br>${descripcion.slice(posicionSalto)}`;
    return descripcionFormateada;
  }

}
